<template>
  <div class="text-14">
    <input
      v-model="inputValue"
      v-mask="timeRangeMask"
      class="outline-none max-w-90 bg-transparent"
      type="text"
      placeholder="00:00-23:59"
      @blur="setTime"
    >
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    time: String
  },

  emits: ['setTime'],

  setup (props, { emit }) {
    const inputValue = ref(props.time || '')

    function timeMask (value) {
      const hours = [/[0-2]/, value.charAt(0) === '2' ? /[0-3]/ : /[0-9]/]
      const minutes = [/[0-5]/, /[0-9]/]

      return value.length > 2
        ? [...hours, ':', ...minutes]
        : hours
    }

    function timeRangeMask (value) {
      const numbers = value.replace(/[^0-9]/g, '')
      if (numbers.length > 4) {
        return [...timeMask(numbers.substring(0, 4)), '-', ...timeMask(numbers.substring(4))]
      }
      return [...timeMask(numbers)]
    }

    function setTime (value) {
      let timeStart = null
      let timeEnd = null

      const splitedValue = inputValue.value.split('-')

      if (splitedValue[0].length === 5) {
        timeStart = splitedValue[0]
      } else {
        inputValue.value = ''
        timeStart = null
      }

      if (splitedValue[1]?.length === 5) {
        timeEnd = splitedValue[1]
      } else {
        timeEnd = null
        inputValue.value = inputValue.value.substring(0, 5)
      }

      emit('setTime', {
        timeStart,
        timeEnd
      })
    }

    return {
      inputValue,
      // ref
      // data
      // computed
      // function
      timeRangeMask,
      setTime
    }
  }

})

</script>
